/**
 * Cleans up stale service workers and caches from previous PWA deployments.
 * This runs once on app boot to ensure users get the latest version.
 */
export async function clearStaleServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;

  try {
    // Unregister all service workers
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      const success = await registration.unregister();
      if (success) {
        console.log('[SW Cleanup] Unregistered stale service worker:', registration.scope);
      }
    }

    // Clear all caches created by the old service worker
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
        console.log('[SW Cleanup] Deleted cache:', cacheName);
      }
    }
  } catch (error) {
    // Non-critical — don't block app startup
    console.warn('[SW Cleanup] Failed to clean up service worker:', error);
  }
}
